
import React from 'react';

const BondRegistrationContext = React.createContext({});

export default BondRegistrationContext;
